import { FormatPrice, Text } from '@reveni-io/reveni-ui'

import { statuses } from '@/returns/constants'

import * as Styles from './styles'

const ConceptLineItem = ({ lineItem, currency }) => {
  return (
    <Styles.Container>
      <Styles.HeaderContainer>
        <Text type="bodySRegular">{lineItem?.product?.name}</Text>
        <Text type="bodySRegular">
          {lineItem.status && lineItem.status !== statuses.accepted && '-'}
          <FormatPrice currency={currency}>{lineItem?.price}</FormatPrice>
        </Text>
      </Styles.HeaderContainer>
      <div>
        <Text type="bodySRegular">{lineItem?.variant?.title}</Text>
      </div>
    </Styles.Container>
  )
}

export default ConceptLineItem
